import { ArrayParam, StringParam, useQueryParams } from "use-query-params";
import { Input } from "../../components/Input";
import { TextArea } from "../../components/TextArea";
import { Button } from "../../components/Button";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import React, { useEffect } from "react";
import cn from "classnames";
import { useTranslation } from "../../hooks/useTranslation";

type Props = {
  className?: string;
  onApply: (params: RightsFiltersParams) => Promise<any>;
};

export type RightsFiltersParams = {
  display_title?: string | null;
  display_artist_name?: string | null;
  code_isrc_list?: Array<string>;
  release_id_list?: Array<string>;
  limit?: number;
  offset?: number;
};

export const RightsFilters: React.FC<Props> = ({ className, onApply }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useQueryParams({
    display_title: StringParam,
    display_artist_name: StringParam,
    code_isrc_list: ArrayParam,
    release_id_list: ArrayParam
  });

  useEffect(() => {
    void onApply(query as RightsFiltersParams);
  }, []);

  useEffect(() => {
    document.onkeyup = function(e) {
      if (e.key === "Enter" && (e.target as any)?.tagName !== "TEXTAREA") {
        void onApply(query as RightsFiltersParams);
      }
    };

    return () => {
      document.onkeyup = null;
    };
  }, [query]);

  return (
    <div className={className}>
      <div className={cn("flex gap-2")}>
        <Input
          style={{ width: "250px" }}
          defaultValue={query.display_title ?? ""}
          placeholder={`${t("search_by_track_release_title")}`}
          onChange={(v) =>
            setQuery({ display_title: v.trim().length > 0 ? v : null })
          }
        />

        <Input
          style={{ width: "250px" }}
          defaultValue={query.display_artist_name ?? ""}
          placeholder={`${t("search_by_artist_name")}`}
          onChange={(v) =>
            setQuery({ display_artist_name: v.trim().length > 0 ? v : null })
          }
        />

        <Button
          icon={faSearch}
          label={`${t("search")}`}
          onClick={() => onApply(query as RightsFiltersParams)}
        />
      </div>
      <div className={cn("flex gap-2")}>
        <TextArea
          style={{ width: "450px" }}
          defaultValue={query.code_isrc_list?.join("\n") ?? ""}
          placeholder={`${t("search_by_code_isrc")}`}
          className={"mt-2"}
          onChange={(v, e) => {
            let value;
            if (v.trim().length === 0) {
              value = null;
            } else if (
              v.split("\n").filter((x) => x.trim().length > 0).length === 0
            ) {
              value = null;
            } else {
              value = v.split("\n");
            }

            setQuery({
              code_isrc_list: value
            });
          }}
        />

        <TextArea
          style={{ width: "450px" }}
          defaultValue={query.release_id_list?.join("\n") ?? ""}
          placeholder={`${t("search_by_release_id")}`}
          className={"mt-2"}
          onChange={(v) => {
            let value;
            if (v.trim().length === 0) {
              value = null;
            } else if (
              v.split("\n").filter((x) => x.trim().length > 0).length === 0
            ) {
              value = null;
            } else {
              value = v.split("\n");
            }
            setQuery({ release_id_list: value });
          }}
        />
      </div>
    </div>
  );
};
